<template>
  <div class="compressed-content">
    <h3>Have you ever had ANY tests or noninvasive imaging to detect arterial blockage?<br /><i>(Check all that apply)</i></h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.blockageTests">
      <b-form-checkbox v-model="survey.arteryBlockages.blockageTests.hadNoTest" @change="onNoTestSelected">
        No
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.arteryBlockages.blockageTests.hadCacTest" @change="onCacTestSelected">
        Coronary artery calcium score (CAC)
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.arteryBlockages.blockageTests.hadHeartAngiogramTest" @change="onHeartAngiogramSelected">
        Heart catheterization (angiogram)
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.arteryBlockages.blockageTests.hadCtaTest" @change="onCtaTestSelected">
        CT angiogram (CTA)
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.arteryBlockages.blockageTests.hadCimtTest" @change="onCimtTestSelected">
        Ultrasound of neck arteries (CIMT or doppler scan)
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.arteryBlockages.blockageTests.hadLegAngiogramTest" @change="onLegAngiogramSelected">
        Ultrasound or angiogram of leg arteries
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.arteryBlockages.blockageTests.hadAnkleBrachialTest" @change="onAnkleBrachialTestSelected">
        Blood pressure check of leg arteries (ankle brachial index – ABI)
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.arteryBlockages.blockageTests.hadCarotidAngiogramTest" @change="onCarotidAngiogramTestSelected">
        Carotid Angiogram
      </b-form-checkbox>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');
  import { anyOptionRequired } from 'utils/custom-validators';

  export default {
    mixins: [formMixin],

    validations: {
      blockageTests: {
        anyOptionRequired: anyOptionRequired((value) => value.hadNoTest || value.hadCacTest
          || value.hadHeartAngiogramTest || value.hadCtaTest || value.hadCimtTest
          || value.hadLegAngiogramTest || value.hadAnkleBrachialTest || value.hadCarotidAngiogramTest)
      }
    },

    computed: {
      ...mapState(["survey"]),

      blockageTests() { return this.survey.arteryBlockages.blockageTests; }
    },

    methods: {
      onNoTestSelected(value) {
        this.setOptions(value, false, false, false, false, false, false, false);
      },

      onCacTestSelected(value) {
        this.setOptions(false, value, this.blockageTests.hadHeartAngiogramTest, this.blockageTests.hadCtaTest,
          this.blockageTests.hadCimtTest, this.blockageTests.hadLegAngiogramTest, this.blockageTests.hadAnkleBrachialTest, this.blockageTests.hadCarotidAngiogramTest);
      },

      onHeartAngiogramSelected(value) {
        this.setOptions(false, this.blockageTests.hadCacTest, value, this.blockageTests.hadCtaTest,
          this.blockageTests.hadCimtTest, this.blockageTests.hadLegAngiogramTest, this.blockageTests.hadAnkleBrachialTest, this.blockageTests.hadCarotidAngiogramTest);
      },

      onCtaTestSelected(value) {
        this.setOptions(false, this.blockageTests.hadCacTest, this.blockageTests.hadHeartAngiogramTest, value,
          this.blockageTests.hadCimtTest, this.blockageTests.hadLegAngiogramTest, this.blockageTests.hadAnkleBrachialTest, this.blockageTests.hadCarotidAngiogramTest);
      },

      onCimtTestSelected(value) {
        this.setOptions(false, this.blockageTests.hadCacTest, this.blockageTests.hadHeartAngiogramTest, this.blockageTests.hadCtaTest,
          value, this.blockageTests.hadLegAngiogramTest, this.blockageTests.hadAnkleBrachialTest, this.blockageTests.hadCarotidAngiogramTest);
      },

      onLegAngiogramSelected(value) {
        this.setOptions(false, this.blockageTests.hadCacTest, this.blockageTests.hadHeartAngiogramTest, this.blockageTests.hadCtaTest,
          this.blockageTests.hadCimtTest, value, this.blockageTests.hadAnkleBrachialTest, this.blockageTests.hadCarotidAngiogramTest);
      },

      onAnkleBrachialTestSelected(value) {
        this.setOptions(false, this.blockageTests.hadCacTest, this.blockageTests.hadHeartAngiogramTest, this.blockageTests.hadCtaTest,
          this.blockageTests.hadCimtTest, this.blockageTests.hadLegAngiogramTest, value, this.blockageTests.hadCarotidAngiogramTest);
      },

      onCarotidAngiogramTestSelected(value) {
        this.setOptions(false, this.blockageTests.hadCacTest, this.blockageTests.hadHeartAngiogramTest, this.blockageTests.hadCtaTest,
          this.blockageTests.hadCimtTest, this.blockageTests.hadLegAngiogramTest, this.blockageTests.hadAnkleBrachialTest, value);
      },

      setOptions(hadNoTest, hadCacTest, hadHeartAngiogramTest, hadCtaTest, hadCimtTest, hadLegAngiogramTest, hadAnkleBrachialTest, hadCarotidAngiogramTest) {
        this.survey.arteryBlockages.blockageTests.hadNoTest = hadNoTest;
        this.survey.arteryBlockages.blockageTests.hadCacTest = hadCacTest;
        this.survey.arteryBlockages.blockageTests.hadHeartAngiogramTest = hadHeartAngiogramTest;
        this.survey.arteryBlockages.blockageTests.hadCtaTest = hadCtaTest;
        this.survey.arteryBlockages.blockageTests.hadCimtTest = hadCimtTest;
        this.survey.arteryBlockages.blockageTests.hadLegAngiogramTest = hadLegAngiogramTest;
        this.survey.arteryBlockages.blockageTests.hadAnkleBrachialTest = hadAnkleBrachialTest;
        this.survey.arteryBlockages.blockageTests.hadCarotidAngiogramTest = hadCarotidAngiogramTest;
      }
    }
  };
</script>